// ./games/crash/state/phases/WaitingPhase.ts
import { isStompTick, StompMessage } from '@core/Web/types/StompMessage';
import type { IPhase, PhaseContext } from './IPhase';
import { FlyingPhase } from './FlyingPhase';
import type { BetBoxState, BetSide } from '@platform/contracts';

export class WaitingPhase implements IPhase {
  private context: PhaseContext;

  constructor(context: PhaseContext) {
    this.context = context;
  }

  onEnter(): void {
    console.log('[Phase] ==> Entering WAITING phase.');
    // The reset function is now safe to call without arguments
    this.context.store.getState().resetForNextRound();

    // Audio call disabled for now
    // if (this.context.audio) {
    //   this.context.audio.play('wait');
    // } else {
    //   console.warn('[WaitingPhase] Audio context not available, skipping wait sound');
    // }

    const bets = this.context.store.getState().bets;
    const armedBets = (Object.entries(bets) as [BetSide, BetBoxState][]).filter(
      ([, bet]) => bet.status === 'armed'
    );

    if (armedBets.length > 0) {
      console.log(
        `[Phase] Found ${armedBets.length} armed bet(s). Placing them now.`
      );
      for (const [side] of armedBets) {
        this.context.controller.place(side as BetSide);
      }
    }
  }

  onExit(): void {
    console.log('[Phase] <== Exiting WAITING phase.');
  }

  handleMessage(message: StompMessage): void {
    // MODIFIED: Changed > to >= to transition on the 1.00x tick
    if (isStompTick(message) && message.multiplier >= 1.0) {
      console.log(
        `[Phase] Received first tick >= 1.0 (${message.multiplier}x). Transitioning to FLYING.`
      );
      this.context.manager.transitionTo(new FlyingPhase(this.context));
    }
  }

  update(_deltaTime: number): void {}
}
